/**
 * Army color themes, based on the rulebook palette.
 *
 * Armies store the theme id rather than the colors themselves, so that the
 * palette can be tuned without migrating any data.
 */
export const themes = {
  teal: { name: "Teal", background: "#98D9C4", text: "#593D8F" },

  // The rulebook uses #56368C for text on lilac and rose backgrounds, which
  // falls below WCAG AA contrast, so it is darkened here.
  lilac: { name: "Lilac", background: "#c19ec5", text: "#3C2662" },
  rose: { name: "Rose", background: "#fb8cac", text: "#2d1c4a" },
  citron: { name: "Citron", background: "#E6E782", text: "#7D274B" },
} satisfies Record<string, { name: string; background: string; text: string }>;

export type ThemeId = keyof typeof themes;

export const themeIds = Object.keys(themes) as ThemeId[];

export const DEFAULT_THEME: ThemeId = "teal";

export function isThemeId(value: unknown): value is ThemeId {
  return (themeIds as unknown[]).includes(value);
}
